<app-filter-card
  i18n-heading
  heading="Rechnungsfilter"
  testId="invoice-filter"
  [canReset]="isFiltered"
  (reset)="resetFilter()"
>
  @if (isRetailer) {
    <div class="col-12 col-md-3">
      <label for="invoiceFilterCustomer" class="form-label" i18n>Kundenname/Nummer</label>
      <input
        id="invoiceFilterCustomer"
        data-testid="invoice-filter-customer-input"
        class="form-control"
        type="text"
        [(ngModel)]="filter.customerNameOrNumber"
        (input)="searchThis()"
      />
    </div>
    <div class="col-12 col-md-3">
      <label for="invoiceFilterGroup" class="form-label" i18n>Rechnungslauf</label>
      <kendo-dropdownlist
        id="invoiceFilterGroup"
        class="w-100"
        data-testid="invoice-filter-group-dropdown"
        [data]="invoiceGroups"
        [defaultItem]="defaultInvoiceGroup"
        [(ngModel)]="invoiceGroupId"
        textField="groupName"
        valueField="id"
        [valuePrimitive]="true"
        (selectionChange)="invoiceGroupChange($event)"
      >
      </kendo-dropdownlist>
    </div>
  }
  <app-date-range-filter
    testId="invoice-filter-date"
    [(from)]="filter.dateFrom"
    [(to)]="filter.dateTo"
    (rangeChange)="searchCriteria.emit(filter)"
  ></app-date-range-filter>
</app-filter-card>
